import styled from 'styled-components';
import { getMaxWidthQuery } from 'helpers/breakpoints';
import Button from 'components/ui/Button/Button';
import FilterButton from 'components/search/v2/Filter/FilterButton';
import { FlexAlignCenterSpaceBetween } from 'components/primitives/flex';
import { breakpoints } from 'components/search/v2/styleConstants';

export const FilterButtonWithMobileDrawer = (props) => {
  const {
    title,
    label,
    content,
    onClear,
    onShowResults,
    isFilterActiveAtom,
    isFilterHiddenAtom,
    name,
    toggleDropdown,
    dropdownActive,
    disabled,
    containerRef,
  } = props;
  return (
    <FilterButton
      ref={containerRef}
      name={name}
      dropdownActive={dropdownActive}
      toggleFilterDropdown={toggleDropdown || undefined}
      hideCloseButton
      showCloseCross
      mobileBottomSheet
      isFilterActiveAtom={isFilterActiveAtom}
      isFilterHiddenAtom={isFilterHiddenAtom}
      disabled={disabled}
      label={label}
      content={
        <>
          <MobileTitle>{title}</MobileTitle>
          {content}
        </>
      }
      extraElementOutsideContent={
        <BottomBar>
          <ClearButton type="button" onClick={onClear}>
            Clear
          </ClearButton>
          <Button text="Show results" className="resultsBtn" onClick={onShowResults} />
        </BottomBar>
      }
    />
  );
};

const MobileTitle = styled.div`
  display: none;
  ${getMaxWidthQuery(breakpoints.QUICK_FILTER_BOTTOM_SHEET_MAX)} {
    display: block;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    color: #17263c;
    padding-bottom: 24px;
  }
`;

const BottomBar = styled(FlexAlignCenterSpaceBetween)`
  position: sticky;
  inset: 0 0 0 0;
  top: unset;
  background: #ffffff;
  box-shadow: 0px -4px 10px rgba(0, 0, 0, 0.04);
  padding: 20px 20px 24px;
  display: none;

  ${getMaxWidthQuery(breakpoints.QUICK_FILTER_BOTTOM_SHEET_MAX)} {
    display: flex;
  }

  .resultsBtn {
    padding: 0 22px;
    background-color: #0751c2;
    text-transform: none;

    span {
      font-weight: 600;
    }
  }
`;

const ClearButton = styled.button`
  font-weight: 500;
  font-size: 16px;
  color: #17263c;
  padding: 18px 22px;
  text-decoration: underline;
`;
